import React from 'react';
import { NavLink } from 'react-router-dom';

const DesignationsCrumb = () => <NavLink to="/admin/designations">Designations</NavLink>;

export default DesignationsCrumb;
